import { get } from './http';

// PageParam 的 pageSize 上限（@Max(200)）。
// 注意：PageParam.PAGE_SIZE_NONE(-1) 用不了，因为同一个字段上有 @Min(1) 校验，会被打回。
export const PAGE_SIZE_MAX = 200;

// 项目类型精简列表（取自字典 ops_web_project_type，已排除地图类型）
export const getTypeSimpleList = () => get('/portal/web-project/type-simple-list');

// 地图类型精简列表（取自字典 ops_web_project_map_type）
export const getMapTypeSimpleList = () => get('/portal/web-project/map-type-simple-list');

// 典型案例分页：开启中的、非地图类型的项目
export const getCasePage = params => get('/portal/web-project/case-page', params);

// 地图详解分页：开启中的、地图类型的项目
export const getMapPage = params => get('/portal/web-project/map-page', params);
